"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallSourceProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _state = require("../state");
var _standardAbis = _interopRequireDefault(require("./standard-abis"));
var _chainClient = require("@blockwell/chain-client");
class CallSourceProvider {
  constructor() {
    (0, _defineProperty2.default)(this, "name", "call");
  }
  getValue(provider, source, arg, step) {
    if (!source.abi) {
      throw new Error(`Missing ABI for CallProvider.`);
    }
    let abi;
    if (typeof source.abi === "string") {
      abi = _standardAbis.default[source.abi];
    } else {
      abi = source.abi;
    }
    return {
      async value() {
        let res;
        let addressSources = [source.address, step === null || step === void 0 ? void 0 : step.address];
        let networkSources = [step === null || step === void 0 ? void 0 : step.network];
        let address = await (0, _state.resolveStringSourcable)(provider, addressSources, step);
        if (!address) {
          console.warn("No address in call source provider");
          return null;
        }
        let network = await (0, _state.resolveStringSourcable)(provider, networkSources, step);
        if (!address) {
          console.warn("No network in call source provider");
          return null;
        }
        let args = [];
        if (source.arguments) {
          if (Array.isArray(source.arguments)) {
            args = source.arguments;
          } else {
            args.push(source.arguments);
          }
        }
        try {
          res = await _chainClient.Chain.readContract(network, address, [abi], abi.name, args);
        } catch (err) {
          console.warn("CallSourceProvider readContract error", {
            err,
            source,
            address
          });
        }
        const decimals = await (0, _state.resolveBigNumberishSourcable)(provider, [arg === null || arg === void 0 ? void 0 : arg.decimals], step);
        if (res && decimals) {
          if (Array.isArray(res)) {
            res = res.map(it => {
              if (typeof it === "string" || typeof it === "number") {
                return new _bignumber.default(it).div(`1e${decimals}`).toString(10);
              }
              return null;
            });
          } else {
            if (typeof res === "string" || typeof res === "number") {
              res = new _bignumber.default(res).div(`1e${decimals}`).toString(10);
            }
          }
        }
        return res;
      }
    };
  }
}
exports.CallSourceProvider = CallSourceProvider;
//# sourceMappingURL=CallSourceProvider.js.map